export const sizeData = {
  ff1: {
    w: 356,
    h: 91
  },
  ff2: {
    w: 354,
    h: 91
  },
  ff3: {
    w: 289,
    h: 91
  },
  ff4: {
    w: 287,
    h: 91
  },
  ff5: {
    w: 287,
    h: 91
  },
  ff6: {
    w: 318,
    h: 91
  },
  fm2: {
    w: 290,
    h: 90
  },
  fm3: {
    w: 290,
    h: 90
  },
  fm4: {
    w: 292,
    h: 91
  },
  fm5: {
    w: 288,
    h: 92
  },
  mf1: {
    w: 356,
    h: 91
  },
  mf2: {
    w: 354,
    h: 91
  },
  mf3: {
    w: 289,
    h: 91
  },
  mf4: {
    w: 287,
    h: 91
  },
  mf5: {
    w: 287,
    h: 91
  },
  mf6: {
    w: 318,
    h: 91
  },
  mm2: {
    w: 290,
    h: 91
  },
  mm3: {
    w: 290,
    h: 91
  },
  mm4: {
    w: 292,
    h: 91
  },
  mm5: {
    w: 288,
    h: 92
  }
}
